export const HideLoader = () => {
  const loader = document.querySelector('[data-loader]');
  if (loader) {
    loader.classList.add('loaded');
  }
};
